import { render, staticRenderFns } from "./OldTargetPriceTooltip.vue?vue&type=template&id=05abb7c4&scoped=true"
import script from "./OldTargetPriceTooltip.vue?vue&type=script&lang=js"
export * from "./OldTargetPriceTooltip.vue?vue&type=script&lang=js"
import style0 from "./OldTargetPriceTooltip.vue?vue&type=style&index=0&id=05abb7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05abb7c4",
  null
  
)

export default component.exports